import { render } from "./billingAddress.vue?vue&type=template&id=2757faf9&ts=true"
import script from "./billingAddress.vue?vue&type=script&lang=ts"
export * from "./billingAddress.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__